import { produce } from "immer";
import {
  UPDATE_FOLDER_BREADCRUMB,
  UPDATE_FOLDER_FILTERS,
  UPDATE_FOLDER_SEARCH,
  TRIGGER_FETCH,
} from "./constants";

export const initialState = {
  folderBreadcrumb: [
    {
      name: "Policy",
      slug: "/d/policy",
    },
  ],
  folderFilters: {
    type: "",
    sort_by: "",
    order: "asc",
  },
  folderSearch: "",
  trigger: false,
};

const FolderActionReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case UPDATE_FOLDER_BREADCRUMB:
        draft.folderBreadcrumb = action.payload;
        break;
      case UPDATE_FOLDER_FILTERS:
        draft.folderFilters = { ...draft.folderFilters, ...action.payload };
        break;
      case UPDATE_FOLDER_SEARCH:
        draft.folderSearch = action.payload;
        break;
      case TRIGGER_FETCH:
        draft.trigger = !draft.trigger;
        break;
      default:
        return state;
    }
  });

export default FolderActionReducer;
